import initialState from './initialState';
import {
  UPDATE_ACCOUNT_NAME,
  UPDATE_ACCOUNT_NAME_DONE,
  UPDATE_ACCOUNT_NAME_ERROR,
  UPDATE_ACCOUNT_NAME_LOADING,
  UPDATE_ACCOUNT_NAME_SUCCESS
} from '../actions/actionTypes';

// handles Account Administrator list related actions

const reducerAccountName = (state, action) => {
  switch (action.type) {
    case UPDATE_ACCOUNT_NAME_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case UPDATE_ACCOUNT_NAME_SUCCESS:
      return {
        ...state,
        error: null
      };
    case UPDATE_ACCOUNT_NAME_ERROR:
      return {
        ...state,
        error: action.error
      };
    case UPDATE_ACCOUNT_NAME_DONE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(UPDATE_ACCOUNT_NAME)) {
    return reducerAccountName(state, action);
  } else {
    return state;
  }
};
